// src/forms/add-board-content/add-post/published-post/PostComments.jsx
import { useState } from 'react';

import XIcon from '@/shared-components/icons/components/public/XIcon';
import Text from '@/shared-components/text/components/Text';

import CommentForm from '../../shared-components/board-comments/CommentForm';
import CommentList from '../../shared-components/board-comments/CommentList';

import './PostComments.css';

export default function PostComments({
  postId,
  onCommentAdded,
  scrollToComments = false,
  isFirstComment = false,
}) {
  // used to force the list to reload
  const [refreshKey, setRefreshKey] = useState(0);
  // which comment are we replying to? `null` => top-level
  const [replyTo, setReplyTo]       = useState(null);
  // after posting, remember which thread to reopen
  const [lastReplyParentId, setLastReplyParentId] = useState(null);

  const handleNew = () => {
    // Remember the top‐level comment ID to re-open that thread after remount
    setLastReplyParentId(replyTo ? (replyTo.comment_parent ?? replyTo._id) : null);
    // clear the reply form
    setReplyTo(null);
    // force CommentList to remount (so it can read lastReplyParentId)
    setRefreshKey(k => k + 1);
    // function to update comment number in parent component
    onCommentAdded();
  };

  return (
    <div className="post-comments-container">
      {/* 1) scrolling list in row 1 */}
      <div className="post-comments-list">
        <CommentList
          key={refreshKey}
          resourceType="post"
          resourceId={postId}
          onReply={c => setReplyTo(c)}
          lastReplyParentId={lastReplyParentId}
          scrollToComments={scrollToComments}
        />
      </div>
      {/* 2) form in row 2 */}
      <div className="post-comments-form">
        {replyTo && (
          <div className="post-comments-reply-status">
            <Text className="post-comments-reply-text font-size-small">
              Replying to <span>@{replyTo.commenter.user_username}</span>
            </Text>
            <button
              type="button"
              className="post-comments-reply-close"
              onClick={() => setReplyTo(null)}
            >
              <XIcon />
            </button>
          </div>
        )}

        <CommentForm
          resourceType="post"
          resourceId={postId}
          parentId={replyTo ? (replyTo.comment_parent ?? replyTo._id) : null}
          replyToUser={replyTo?.commenter.user_username}
          isFirstComment={isFirstComment}
          onNewComment={handleNew}
        />
      </div>
    </div>
  );
}
